import axiosInstance from '../../axios-config';

const careTeamApi = '/api/patients/{0}/careTeamMembers';
const userProfileImageUrlTemplate = '/api/images/userprofileimage/{fileName}';

export const getCareTeam = (patientId) => (
  axiosInstance.get(careTeamApi.replace('{0}', patientId))
);

export const getUserProfileImageUrl = (fileName) => (
  axiosInstance.defaults.baseURL.concat(userProfileImageUrlTemplate.replace('{fileName}', fileName))
);
